

























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import DatePicker from '@/components/form/DatePicker.vue';
import { CashAccountType, OpenCashAccount } from '@/modules/listOfAssets/types';
import { ApiResponse } from '@/components/types';
import { createOpenCashAccount } from '@/modules/listOfAssets/model';
import { OPEN_CASH_ACCOUNT } from '@/modules/listOfAssets/store/cashAccount';

const CashAccount = namespace('listOfAssets/cashAccount');

@Component({
  components: {
    DatePicker
  }
})
export default class AccountSelectForm extends Vue {
  @Prop({ type: String, required: true }) listOfAssetsId!: string;
  @Prop({ type: String, required: true }) type!: CashAccountType;

  @CashAccount.Action(OPEN_CASH_ACCOUNT) openAccount!: (params: OpenCashAccount) => Promise<ApiResponse>;

  error: any = null;

  value: OpenCashAccount = createOpenCashAccount(this.listOfAssetsId, this.type);

  reset() {
    setTimeout(() => {
      this.error = null;
      this.value = createOpenCashAccount(this.listOfAssetsId, this.type);
    }, 300);
  }

  cancel() {
    this.reset();
    this.$emit('cancel');
  }

  back() {
    this.reset();
    this.$emit('back');
  }

  save() {
    this.error = null;

    return this.openAccount(this.value);
  }
}
